import { FC } from 'react';
import { Game } from '../games.model';
import { SectionType } from '../GameCard/GameCard.types';
import {
  GridLayout,
  TallLayout,
  TallReverseLayout,
  WideLayout,
  WideReverseLayout,
  DoubleTallLayout,
  DoubleWideLayout,
  TallPlusGridLayout,
  HeroPlusTallLayout,
  HeroLayout,
} from './layouts';
import { createSharedLayoutProps } from './utils';
import './GameGrid.scss';

interface GameGridProps {
  sectionType: SectionType;
  games: Game[];
  disabled?: boolean;
  showGameName?: boolean;
  fallbackImageAltText?: string;
  fallbackImageUrl?: string;
  onViewGameInfo?: (game: Game) => void;
  onPlayDemo?: (game: Game) => void;
  onPlayGame?: (game: Game) => void;
  containerElementWidth?: number;
}

export const GameGrid: FC<GameGridProps> = ({
  sectionType,
  games,
  disabled = false,
  showGameName = true,
  fallbackImageAltText = '',
  fallbackImageUrl = '',
  onViewGameInfo,
  onPlayDemo,
  onPlayGame,
  containerElementWidth = 0,
}) => {
  const sharedProps = createSharedLayoutProps(
    games,
    disabled,
    showGameName,
    fallbackImageAltText,
    fallbackImageUrl,
    onViewGameInfo,
    onPlayDemo,
    onPlayGame,
    containerElementWidth
  );

  const renderGridSection = (): JSX.Element | null => {
    switch (sectionType) {
      case SectionType.GRID:
        return <GridLayout {...sharedProps} />;
      case SectionType.TALL:
        return <TallLayout {...sharedProps} />;
      case SectionType.TALL_REVERSE:
        return <TallReverseLayout {...sharedProps} />;
      case SectionType.WIDE:
        return <WideLayout {...sharedProps} />;
      case SectionType.WIDE_REVERSE:
        return <WideReverseLayout {...sharedProps} />;
      case SectionType.DOUBLE_TALL:
        return <DoubleTallLayout {...sharedProps} />;
      case SectionType.DOUBLE_WIDE:
        return <DoubleWideLayout {...sharedProps} />;
      case SectionType.HERO:
        return <HeroLayout {...sharedProps} />;
      case SectionType.TALL_PLUS_GRID:
        return <TallPlusGridLayout {...sharedProps} />;
      case SectionType.GRID_PLUS_TALL:
        return <TallPlusGridLayout {...sharedProps} reverse />;
      case SectionType.HERO_PLUS_TALL:
        return <HeroPlusTallLayout {...sharedProps} />;
      case SectionType.TALL_PLUS_HERO:
        return <HeroPlusTallLayout {...sharedProps} reverse />;
      default:
        return null;
    }
  };

  return (
    <div className={`game-grid-wrapper game-grid-wrapper--${sectionType.toLowerCase()}`}>{renderGridSection()}</div>
  );
};
